module.exports = __webpack_public_path__ + "assets/img/carousel_2.8f6191cf.png";